import { Box, CircularProgress, Typography } from '@mui/material'

type Props = {
  isProcessing: boolean
  isCompleted: boolean
  stepNumber: number
  title: string
  text: string
}
const Step = ({ stepNumber, isProcessing, isCompleted, title, text }: Props) => {
  const textColor = isCompleted ? 'black' : isProcessing ? 'primary.main' : '#ccc'
  const percentage = isCompleted ? 100 : 0
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2,
        marginBottom: 2,
        opacity: isCompleted ? 1 : isProcessing ? 1 : 0.5,
      }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <Typography variant="h6" sx={{ color: textColor, fontWeight: 'bold' }}>
          Step {stepNumber}
        </Typography>
        <Typography variant="h6" sx={{ color: textColor, fontWeight: 'bold' }}>
          {percentage}%
        </Typography>
      </Box>
      <Box p={3} sx={{ flex: 1, marginLeft: 2, border: `1px solid`, borderColor: textColor, borderRadius: 8 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', color: textColor }}>
          {title} {isProcessing && '- Processing...'}
        </Typography>
        <Typography fontSize={14} sx={{ whiteSpace: 'pre-line', color: textColor }}>
          {text}
        </Typography>
      </Box>
      <Box width={100} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {isProcessing && <CircularProgress size={44} sx={{ color: 'primary.main' }} />}
      </Box>
    </Box>
  )
}

export default Step
